import React, { FC } from 'react';
import { SkeletonWrapper } from './Skeleton.styles';
import { SkeletonProps } from './types';

const Skeleton: FC<SkeletonProps> = ({ className, ...props }) => <SkeletonWrapper {...props} className={className} />;

export default Skeleton;
